import React from 'react';
import {
    Datagrid,
    DateField,
    TextField,
    ReferenceField,
    NumberField,
    Filter,
    List,
    SearchInput,
    downloadCSV,
} from 'react-admin';

import jsonExport from 'jsonexport/dist';
import FullNameField from '../fields/users/FullNameField';
const UserFilter = (props: any) => (
    <Filter {...props}>
        <SearchInput source="q" alwaysOn />
    </Filter>
);

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const exporter = users => {
    const usersForExport = users.map(user => {
        let created_at = new Date(user.created_at).toLocaleDateString('fr-FR', {
            year: 'numeric',
            month: 'numeric',
            day: 'numeric',
        });
        return {
            name: user.name.fill,
            email: user.email,
            phone: user.phone,
            civility: user.civility,
            created_at: created_at,
        };
    });
    jsonExport(usersForExport, {}, (err, csv) => {
        downloadCSV(csv, 'drivers'); // download as 'posts.csv` file
    });
};

const UserList = (props: any) => {
    return (
        <List
            {...props}
            filters={<UserFilter />}
            sort={{ field: 'created_at', order: 'DESC' }}
            perPage={10}
            bulkActionButtons={false}
            // aside={<UserListAside />}
        >
            <Datagrid optimized rowClick="edit">
                <DateField
                    source="created_at"
                    type="date"
                    label="resources.drivers.fields.created_at"
                    showTime
                    options={{
                        hourCycle: 'h23',
                    }}
                />
                <FullNameField
                    source="name"
                    label="resources.drivers.fields.name.full"
                />
                <ReferenceField
                    label="Type de véhiculee"
                    source="vehicle_type"
                    reference="vehicles"
                >
                    <TextField source="name" />
                </ReferenceField>
                <TextField
                    source="phone"
                    label="resources.drivers.fields.phone"
                />
                <TextField
                    source="email"
                    label="resources.drivers.fields.email"
                />
                <TextField
                    source="commission_rate"
                    label="resources.drivers.fields.commission"
                />
                <NumberField
                    source="nb_courses"
                    label="resources.drivers.fields.nb_courses"
                />
            </Datagrid>
        </List>
    );
};

export default UserList;
